import ArbitrumIcon from "@/assets/icons/networks/arbitrum.svg?react";
import BaseIcon from "@/assets/icons/networks/base.svg?react";
import BscIcon from "@/assets/icons/networks/bsc.svg?react";
import EthereumIcon from "@/assets/icons/networks/evm.svg?react";
import LineaIcon from "@/assets/icons/networks/linea.svg?react";
import NearIcon from "@/assets/icons/networks/near.svg?react";
import SolanaIcon from "@/assets/icons/networks/solana.svg?react";
import StellarIcon from "@/assets/icons/networks/stellar.svg?react";
import TonIcon from "@/assets/icons/networks/ton.svg?react";
import { Network } from "@/interfaces/network";

export const NetworkIconMap: Record<Network, JSX.Element> = {
  [Network.NEAR]: <NearIcon />,
  [Network.BASE]: <BaseIcon className="default-network-icon-circle" />,
  [Network.LINEA]: <LineaIcon />,
  [Network.BSC]: <BscIcon className="default-network-icon-circle" />,
  [Network.TON]: <TonIcon className="default-network-icon-circle" />,
  [Network.TON_TESTNET]: <TonIcon className="default-network-icon-circle" />,
  [Network.SOLANA]: <SolanaIcon className="default-network-icon-path" />,
  [Network.ARBITRUM]: <ArbitrumIcon className="default-network-icon-circle" />,
  [Network.STELLAR]: <StellarIcon className="default-network-icon-circle" />,
  [Network.ETHEREUM]: <EthereumIcon className="default-network-icon-circle" />,
};

export const ColoredNetworkIconMap: Record<Network, JSX.Element> = {
  [Network.NEAR]: <NearIcon />,
  [Network.BASE]: <BaseIcon />,
  [Network.LINEA]: <LineaIcon />,
  [Network.BSC]: <BscIcon />,
  [Network.TON]: <TonIcon />,
  [Network.TON_TESTNET]: <TonIcon />,
  [Network.SOLANA]: <SolanaIcon />,
  [Network.ARBITRUM]: <ArbitrumIcon />,
  [Network.STELLAR]: <StellarIcon />,
  [Network.ETHEREUM]: <EthereumIcon />,
};
